import React, { useEffect, useState } from 'react'

import './modalProdutoCompra.css'
import customizeScrollbar from 'customsb';
import api from '../../services/api';
import { vhostV1 } from '../funcoes';
import BuscaVazaia from '../components/buscavazia/buscaVazia';
import { Modal } from 'react-bootstrap';


function ModalProdutoCompra({isOpenMod,onRequestClose,setCodProduto,setDescricao,setVendaDefault,setCompra}){

  let config = {
    headers: {
      'Authorization': localStorage.getItem("token")
    }
  }

  useEffect(() => {
    // O uso do useEffect garante que a função seja chamada apenas no lado do cliente
    customizeScrollbar({
      scrollbarWidth: "10px",
      trackBackground: "#333",
      thumbBackground:
        "linear-gradient(178.8deg, #ffa066 47.41%, #ff9666 65.18%, #ff783a 90.84%)",
      thumbBorderRadius: "10px",
    });
  }, []);

  const [produtos,setProdutos] = useState([]);
  const [busca,setBusca] = useState('');
  
  // const [codProduto, setCodProduto] = useState('');
  // const [descricao, setDescricao] = useState('');
  // const [vendaDefault, setVendaDefault] = useState(0);

  const diferenteZero = false;
  const estoqueNegativo = false;
  const vendaZerada = false;
  const prodInativo =false;

  function filtraProdutos(){
  const sJson = {}
  sJson.loja=localStorage.getItem('loja'); 
  sJson.empresa=0;
  sJson.grupo=0;
  sJson.subgrupo=0;
  sJson.linha=0;
  sJson.estoque_diferente=diferenteZero
  sJson.estoque_negativo=estoqueNegativo;
  sJson.preco_zerado=vendaZerada;
  sJson.inativo=prodInativo;
  sJson.pagina= 1;
  sJson.regPag=10;
  sJson.busca= busca; 
  sJson.tipoBusca=0; 
  sJson.tipo_prod=''; 
 
    api.post(vhostV1('webcash/produto/listar'),sJson,config)
      .then(function (response) {
          if(response && response.data && response.data.dados ){
            console.log(response.data.dados)
            setProdutos(response.data.dados);  
          }else{ 
          setProdutos([]);  
      }
                                    
      })
      .catch(function (error) {
        console.log(error);                  
      });
        
}              



  function handelProduto(prod){
     setCodProduto(prod.COD_PRODUTO);
     setDescricao(prod.DESCRICAO);
     setVendaDefault(Number(prod.VENDA));
     setCompra(prod.COMPRA);
     onRequestClose();

  }



  return (
    <Modal
      show={isOpenMod}
      onHide={onRequestClose}
      size="lg"
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton>
        <Modal.Title>Pesquisa Produtos</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="input-group mb-3">
                <input 
                  onChange={(e) => setBusca(e.target.value)} 
                  type="text" 
                  className="form-control" 
                  placeholder="Pesquisar por nome" 
                  aria-describedby="button-addon2" 
                  autoFocus 
                />
                <button 
                  onClick={(e) => filtraProdutos(e.target.value)} 
                  value={busca} 
                  className="btn btn-primary" 
                  type="button" 
                  id="button-addon2">
                  <i className="bi bi-search"></i> Pesquisar
                </button>
              </div>
            </div>
          </div>

          <div className="row">
            {produtos.length > 0 ? (
              <table className="table table-hover table-striped">
                <thead>
                  <tr>
                    <th scope="col">Codigo</th>
                    <th scope="col">Descrição</th>
                    <th scope="col">Estoque</th>
                    <th scope="col">Ação</th>
                  </tr>
                </thead>
                <tbody className="table-group-divider">
                  {produtos.map((prod) => (
                    <tr key={prod.COD_PRODUTO}>
                      <td>{prod.COD_PRODUTO}</td>
                      <td>{prod.DESCRICAO}</td>
                      <td>{Number(prod.ESTOQUE).toFixed(3)}</td>
                      <td>
                        <button onClick={(e) => handelProduto(prod)}>
                          <i className="bi bi-file-arrow-down-fill"></i>
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <BuscaVazaia />
            )}
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <button 
          className="btn btn-danger" 
          onClick={onRequestClose}>
          Cancelar
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default ModalProdutoCompra;